import ChartDataTable from '@/pages/CompanyReport/components/Overview/components/ChartDataTable';
import DocumentSchema from '@/components/DocumentSchema';
import type { Table } from 'schema-dts';
import { useValuationData } from '@/pages/CompanyReport/components/Valuation';
import { useTranslation } from '@/hooks/useTranslation';

export const FairRatioTable = () => {
  const {
    tickerSymbol,
    multiples: { preferredMultiple },
    formattedPreferredMultipleFairRatio,
  } = useValuationData();

  const t = useTranslation();

  return (
    <>
      <DocumentSchema<Table>
        item={{
          '@context': 'https://schema.org',
          '@type': 'Table',
          headline: t('page.companyReport.valuation.vsFair.table.heading'),
          about: t('page.companyReport.valuation.vsFair.table.description', {
            tickerSymbol,
            metric: preferredMultiple.name,
          }),
        }}
      />
      <ChartDataTable data-cy-id="key-metrics-table" columnTextAlignments="l">
        <caption>
          {t('page.companyReport.valuation.vsFair.table.description', {
            tickerSymbol,
            metric: preferredMultiple.name,
          })}
        </caption>
        <thead>
          <tr>
            <th colSpan={2}>
              {t('page.companyReport.valuation.vsFair.table.heading')}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {t('page.companyReport.valuation.vsFair.table.row.current', {
                metric: preferredMultiple.name,
              })}
            </td>
            <td>{preferredMultiple.value}</td>
          </tr>
          <tr>
            <td>
              {t('page.companyReport.valuation.vsFair.table.row.fair', {
                metric: preferredMultiple.name,
              })}
            </td>
            <td>{formattedPreferredMultipleFairRatio}</td>
          </tr>
        </tbody>
      </ChartDataTable>
    </>
  );
};
